export enum EEstateType {
  Owned = 1,
  Rent = 2,
}
